import { Component, type ErrorInfo, type ReactNode } from "react";
import { notifyUnexpectedError } from "../errors";
import { Button, Icon } from "../ui";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    notifyUnexpectedError(error, info.componentStack || "react-render");
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="min-h-screen bg-[var(--paper)] px-8 py-10 flex items-center justify-center">
        <section className="w-full max-w-2xl border-2 border-[var(--strike)] bg-[var(--paper)] p-8">
          <div className="flex items-baseline gap-3 mb-4">
            <Icon.AlertCircle size={22} strokeWidth={2.25} className="text-[var(--strike)]" />
            <div className="label text-[var(--strike)]">Erro inesperado</div>
          </div>
          <h1 className="display-3 mb-4">A interface encontrou uma falha.</h1>
          <p className="lede mb-6">
            Recarregue a pagina antes de continuar. O resultado exibido nesta tela nao deve ser
            usado para validacao.
          </p>
          <div className="caption border-l-2 border-[var(--strike)] pl-4 mb-8 break-words">
            {this.state.error.message}
          </div>
          <Button
            variant="ink"
            icon={Icon.RefreshCw}
            onClick={() => {
              window.location.reload();
            }}
          >
            Recarregar
          </Button>
        </section>
      </main>
    );
  }
}
